import React, { useEffect, useRef, useState, useMemo } from "react";

import {
  ActionIcon,
  Avatar,
  Button,
  Card,
  Grid,
  Group,
  Menu,
  Modal,
  ScrollArea,
  Stack,
  Tabs,
  Text,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  IconCheck,
  IconChecks,
  IconEye,
  IconMinus,
  IconPencil,
  IconPencilPlus,
  IconPlus,
  IconTrashX,
  IconX,
} from "@tabler/icons-react";

import { IconEyeClosed } from "@tabler/icons-react";

import AiChat from "./AiChat";
import { useDisclosure } from "@mantine/hooks";
import fetchApi from "../Lib/api";
import Notification from "../Lib/Notification";
import Markdown from "../Lib/Markdown";
import GoogleDrivePickerAndUploader from "../Lib/FilesPickerAndUploader";
import FileList from "../Lib/FilesDisplay";
import FeatureButton from "../../stories/FeatureButton";
import useStartupStore from "../../stores/startupStore";
import Mixpanel from "../Lib/mixpanel";
import { useTranslation } from "react-i18next";

export default function Editor({
  owner,
  member,
  role,
  programs,
  selectedPrograms,
  close,
  setContent,
  content,
  privacy,
  setPrivacy,
  files,
  setFiles,
  handleSave,
  members,
}) {
  const [index, setIndex] = useState(selectedPrograms.sid);
  const [loading, setLoading] = useState(false);

  return (
    <Stack className="h-full w-full py-4">
      {selectedPrograms && (
        <Group align="start">
          <Title order={3} className="text-gray-700 mb-5">
            {programs.categories[selectedPrograms.cid].name}
          </Title>
          <AssignMembers
            canAssign={owner || role < 2}
            categoryId={programs.categories[selectedPrograms.cid].id}
            members={members}
            assign_members={
              programs.categories[selectedPrograms.cid].assigned_users
            }
          />
        </Group>
      )}

      <Tabs
        variant="pills"
        className="w-full"
        defaultValue={
          programs.categories[selectedPrograms.cid].sub_categories[
            selectedPrograms.sid
          ].name
        }
      >
        <Tabs.List className="bg-gray-100">
          {programs.categories[selectedPrograms.cid].sub_categories.map(
            (tab, i) => {
              if (
                tab.is_active &&
                (owner ||
                  (tab.privacy !== "Only me" && member) ||
                  (tab.privacy === "Everyone" && tab.response))
              )
                return (
                  <Tabs.Tab
                    onClick={() => setIndex(i)}
                    icon={tab.response ? <IconChecks /> : <></>}
                    key={tab.name}
                    value={tab.name}
                    className="font-bold"
                  >
                    {tab.name}
                  </Tabs.Tab>
                );
            }
          )}
        </Tabs.List>

        {programs.categories[selectedPrograms.cid].sub_categories.map(
          (tab, index) => {
            if (
              tab.is_active &&
              (owner ||
                (tab.privacy !== "Only me" && member) ||
                (tab.privacy === "Everyone" && tab.response))
            )
              return (
                <Tabs.Panel key={tab.id} value={tab.name}>
                  <Grid className="w-full" columns={25}>
                    <Grid.Col lg={14} order={1} orderSm={1} orderLg={1}>
                      <Stack>
                        <Markdown
                          value={(content && content[index].response) || ""}
                          visibleDragbar={false}
                          preview={"edit"}
                          hideToolbar={false}
                          height={500}
                          setValue={(e) => {
                            setContent((p) => {
                              const arr = [...p];
                              arr[index].response = e;
                              arr[index].touched = true;
                              return arr;
                            });
                          }}
                        />
                        <GoogleDrivePickerAndUploader
                          clientId={clientId}
                          apiKey={apiKey}
                          setFiles={setFiles}
                          files={files}
                          index={index}
                          dropboxAppKey={dropboxAppKey}
                          total_files_size={tab.total_files_size}
                        >
                          <ScrollArea h={160} type="auto">
                            <FileList fileRecords={files[index]} />
                            <FileList
                              files={tab.files}
                              fileRecords={tab.file_records}
                            />
                          </ScrollArea>
                        </GoogleDrivePickerAndUploader>
                      </Stack>
                    </Grid.Col>
                    <Grid.Col lg={11} order={1} orderSm={2} orderLg={2}>
                      <Stack
                        h="100%"
                        justify="space-between"
                        className="flex flex-col"
                      >
                        <Guide tab={tab} />

                        <AiChat />
                      </Stack>
                    </Grid.Col>
                  </Grid>
                </Tabs.Panel>
              );
          }
        )}
      </Tabs>
      <Group
        position="center"
        // className="overflow-x-auto flex-nowrap lg:flex-wrap"
      >
        {(owner || role < 1) && (
          <Menu
            classNames="min-w-5"
            trigger="hover"
            shadow="md"
            size="md"
            leftIcon={
              privacy !== "Only me" ? (
                <IconEye size="1rem" />
              ) : (
                <IconEyeClosed size="1rem" />
              )
            }
          >
            <Menu.Target>
              <Button variant="default" className="w-fit">
                Privacy
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                onClick={(e) =>
                  setPrivacy((p) => {
                    const arr = [...p];
                    arr[index] = "Everyone";
                    return arr;
                  })
                }
              >
                Everyone
              </Menu.Item>
              <Menu.Item
                onClick={(e) =>
                  setPrivacy((p) => {
                    const arr = [...p];
                    arr[index] = "Members";
                    return arr;
                  })
                }
              >
                Members
              </Menu.Item>
              <Menu.Item
                onClick={(e) =>
                  setPrivacy((p) => {
                    const arr = [...p];
                    arr[index] = "Only me";
                    return arr;
                  })
                }
              >
                Only me
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}

        <Button
          variant="default"
          size="md"
          leftIcon={<IconTrashX size="1rem" />}
          onClick={close}
        >
          Leave without saving
        </Button>
        <Button
          onClick={() => {
            programs.categories[selectedPrograms.cid].sub_categories.forEach(
              (element, i) => {
                if (element.is_active) handleSave(i, setLoading);
              }
            );
          }}
          variant="default"
          size="md"
          leftIcon={<IconPencilPlus size="1rem" />}
          loading={loading}
        >
          Save changes
        </Button>
      </Group>
    </Stack>
  );
}

export const AssignMembers = ({}) => {
  const [otherMembers, setOtherMembers] = useState([]);
  const [opened, { open, close }] = useDisclosure(false);
  const [notification, setNotification] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState({});
  const [activeTab, setActiveTab] = useState("assigned");
  
  const {slug, canAssign, members, assign_members, categoryId, subCategoryId,setProgram,selectedProgram } = useStartupStore(
    (state) => ({
      canAssign: state.isOwner || state.role < 2,
      members: state.members,
      slug: state.slug,
      assign_members: state.program.loading
        ? []
        : state.program.categories[state.selectedProgram.cid].sub_categories[state.selectedProgram.sid].assigned_users,

      categoryId: state.program.categories[state.selectedProgram.cid].id,
      subCategoryId: state.program.categories[state.selectedProgram.cid].sub_categories[state.selectedProgram.sid].id,
      setProgram: state.setProgram,
      selectedProgram: state.selectedProgram
    })
  );

  const [assignMembers, setAssignMembers] = useState(assign_members);
  const {t}=useTranslation();

  // Filter members based on search query
  const filteredAssignedMembers = useMemo(() => {
    if (!searchQuery) return assignMembers;
    return assignMembers.filter(({ user }) => 
      user.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [assignMembers, searchQuery]);

  const filteredOtherMembers = useMemo(() => {
    if (!searchQuery) return otherMembers;
    return otherMembers.filter(user => 
      user.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [otherMembers, searchQuery]);

  const handleRequest = async (accepted, categoryId, subCategoryId, userId) => {
    const actionType = accepted ? "assign_member" : "remove_member";
    
    // Set loading state
    setLoading(prev => ({ ...prev, [userId]: true }));
    
    Mixpanel.custom(`Member ${actionType} Started`, {
      target_user_id: userId,
      category_id: categoryId,
      subcategory_id: subCategoryId,
      startup_slug: slug,
      action: actionType
    });
    const startTime = performance.now();

    try {
      const action = accepted ? "assign_member" : "remove_member";
      const method = accepted ? "POST" : "DELETE";
      
      const response = await fetchApi(
        `/startup_entities/${slug}/categories/${categoryId}/sub_categories/${subCategoryId}/${action}`,
        method,
        { user_id: userId }
      );

      const responseTime = Math.round(performance.now() - startTime);

      if (response.ok) {
        const data = await response.json();
        setNotification({ type: "success", content: data.message });

        let memberToUpdate = null;
        let updatedAssignedUsersInStore = [];

        if (accepted) {
          memberToUpdate = otherMembers.find(member => member.id === userId);
          if (memberToUpdate) {
            setOtherMembers(p => p.filter(member => member.id !== userId));
            setAssignMembers(p => [...p, { user: memberToUpdate }]);

            // Update zustand store
            const currentProgramState = useStartupStore.getState().program;
            const { cid, sid } = selectedProgram;
            updatedAssignedUsersInStore = [
              ...currentProgramState.categories[cid].sub_categories[sid].assigned_users.filter(a => a.user.id !== userId),
              { user: memberToUpdate }
            ];
            const updatedProgram = { ...currentProgramState };
            updatedProgram.categories[cid].sub_categories[sid].assigned_users = updatedAssignedUsersInStore;
            setProgram(updatedProgram);
          }
        } else {
          memberToUpdate = assignMembers.find(member => member.user.id === userId)?.user;
          if (memberToUpdate) {
            setAssignMembers(p => p.filter(member => member.user.id !== userId));
            setOtherMembers(p => [...p, memberToUpdate]);

            // Update zustand store
            const currentProgramState = useStartupStore.getState().program;
            const { cid, sid } = selectedProgram;
            updatedAssignedUsersInStore = currentProgramState.categories[cid].sub_categories[sid].assigned_users.filter(a => a.user.id !== userId);
            const updatedProgram = { ...currentProgramState };
            updatedProgram.categories[cid].sub_categories[sid].assigned_users = updatedAssignedUsersInStore;
            setProgram(updatedProgram);
          }
        }
        
        Mixpanel.settings('Member Assignment', accepted ? 'Assigned' : 'Unassigned', {
            target_user_id: userId,
            category_id: categoryId,
            subcategory_id: subCategoryId,
            startup_slug: slug,
            response_time_ms: responseTime
        });

      } else {
        const errorData = await response.json();
        setNotification({ type: "failure", content: errorData.error });
        console.error(errorData.error); 
        
        const responseTime = Math.round(performance.now() - startTime);
        Mixpanel.error(`Member ${actionType} Error`, {
            error_message: errorData.error,
            error_type: 'API Error',
            component: 'AssignMembers',
            user_action: actionType,
            target_user_id: userId,
            category_id: categoryId,
            subcategory_id: subCategoryId,
            startup_slug: slug,
            http_status: response.status,
            response_time_ms: responseTime
        });
      }
    } catch (error) {
      const responseTime = Math.round(performance.now() - startTime);
      console.error("Error:", error);

      Mixpanel.error(`Member ${actionType} Error`, {
          error_message: error.message,
          error_type: 'Network Error',
          component: 'AssignMembers',
          user_action: actionType,
          target_user_id: userId,
          category_id: categoryId,
          subcategory_id: subCategoryId,
          startup_slug: slug,
          response_time_ms: responseTime
      });
    } finally {
      // Clear loading state
      setLoading(prev => ({ ...prev, [userId]: false }));
    }
  };

  useEffect(() => {
    setOtherMembers(
      members.filter(
        (member) =>
          !assign_members.some(
            (assignMember) => assignMember.user.id === member.id
          )
      )
    );
  }, []);

  return (
    <>
      {opened && (
        <Modal 
          opened={opened} 
          size="lg" 
          onClose={close} 
          withinPortal
          centered
          overlayProps={{ blur: 2 }}
          radius="md"
          styles={{
            content: {
              marginTop: '-10vh'
            }
          }}
        >
          <div className="p-0">

                        {/* Notification */}
            {notification && (
              <div className="px-4 py-2">
                <Notification {...notification} />
              </div>
            )}
            
            {/* Compact Header */}
            <div className="px-4 py-3">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-lg font-semibold">Team Assignment</h2>
                  <p className="text-blue-100 text-xs">Manage member assignments</p>
                </div>
                <Button
                  variant="subtle"
                  color="white"
                  onClick={close}
                  className="hover:bg-white/20 text-white"
                  size="xs"
                >
                  <IconX size={14} />
                </Button>
              </div>
            </div>

            {/* Compact Search and Tabs */}
            <div className="px-4 py-3 bg-gray-50 border-b">
              <div className="flex flex-col gap-3">
                {/* Search Input */}
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search members..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="block w-full pl-10 pr-3 py-2 border border-gray-200 rounded-md text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  />
                </div>

                {/* Compact Tabs */}
                <div className="flex bg-white rounded-md p-1 shadow-sm border">
                  <button
                    onClick={() => setActiveTab("assigned")}
                    className={`flex-1 px-3 py-2 text-xs font-medium rounded-sm transition-all ${
                      activeTab === "assigned"
                        ? "bg-blue-500 text-white shadow-sm"
                        : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                    }`}
                  >
                    Assigned ({filteredAssignedMembers.length})
                  </button>
                  <button
                    onClick={() => setActiveTab("available")}
                    className={`flex-1 px-3 py-2 text-xs font-medium rounded-sm transition-all ${
                      activeTab === "available"
                        ? "bg-blue-500 text-white shadow-sm"
                        : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                    }`}
                  >
                    Available ({filteredOtherMembers.length})
                  </button>
                </div>
              </div>
            </div>

            {/* Compact Content */}
            <div className="max-h-80 overflow-y-auto">
              {activeTab === "assigned" ? (
                <div className="p-3">
                  {filteredAssignedMembers.length === 0 ? (
                    <div className="text-center py-8">
                      <div className="w-12 h-12 mx-auto mb-3 bg-blue-50 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-900 mb-1">No assigned members</h3>
                      <p className="text-xs text-gray-500">Switch to Available tab to assign members</p>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {filteredAssignedMembers.map(({ user }) => (
                        <div key={user.id} className="flex items-center justify-between p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors border border-blue-100">
                          <div className="flex items-center space-x-3">
                            <div className="relative">
                              {user.avatar_url ? (
                                <img
                                  src={user.avatar_url}
                                  alt={`${user.first_name} ${user.last_name}`}
                                  className="w-8 h-8 rounded-full object-cover ring-2 ring-blue-200"
                                />
                              ) : (
                                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium text-xs ring-2 ring-blue-200">
                                  {user.first_name[0]}{user.last_name[0]}
                                </div>
                              )}
                              <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-400 border-2 border-white rounded-full"></div>
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate">
                                {user.first_name} {user.last_name}
                              </p>
                              <p className="text-xs text-gray-600 truncate">{user.email}</p>
                            </div>
                          </div>
                          <Button
                            onClick={() => handleRequest(false, categoryId, subCategoryId, user.id)}
                            variant="light"
                            color="red"
                            size="xs"
                            loading={loading[user.id]}
                            className="hover:bg-red-100 text-red-600"
                          >
                            <IconMinus size={12} />
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div className="p-3">
                  {filteredOtherMembers.length === 0 ? (
                    <div className="text-center py-8">
                      <div className="w-12 h-12 mx-auto mb-3 bg-gray-50 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-900 mb-1">No available members</h3>
                      <p className="text-xs text-gray-500">All members are already assigned</p>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {filteredOtherMembers.map((user) => (
                        <div key={user.id} className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-sm transition-all">
                          <div className="flex items-center space-x-3">
                            <div className="relative">
                              {user.avatar_url ? (
                                <img
                                  src={user.avatar_url}
                                  alt={`${user.first_name} ${user.last_name}`}
                                  className="w-8 h-8 rounded-full object-cover ring-2 ring-gray-200"
                                />
                              ) : (
                                <div className="w-8 h-8 rounded-full bg-gray-400 flex items-center justify-center text-white font-medium text-xs ring-2 ring-gray-200">
                                  {user.first_name[0]}{user.last_name[0]}
                                </div>
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate">
                                {user.first_name} {user.last_name}
                              </p>
                              <p className="text-xs text-gray-600 truncate">{user.email}</p>
                            </div>
                          </div>
                          <Button
                            onClick={() => handleRequest(true, categoryId, subCategoryId, user.id)}
                            variant="filled"
                            color="blue"
                            size="xs"
                            loading={loading[user.id]}
                            className="hover:bg-blue-600"
                          >
                            <IconPlus size={12} />
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}

      {/* Compact Trigger Button */}
      <div>
        <Tooltip.Group openDelay={300} closeDelay={100}>
          <div className="flex items-center gap-1">
            <Avatar.Group spacing="xs">
              {assignMembers.slice(0, 2).map(({ user }) => (
                <Tooltip
                  key={user.id}
                  label={`${user.first_name} ${user.last_name}`}
                  withArrow
                  color="blue"
                  position="top"
                >
                  {user.avatar_url ? (
                    <Avatar
                      src={user.avatar_url}
                      radius="xl"
                      size={28}
                      color="blue"
                      alt={`${user.first_name} ${user.last_name}`}
                      className="ring-2 ring-blue-100"
                    />
                  ) : (
                    <Avatar
                      radius="xl"
                      size={28}
                      color="blue"
                      className="ring-2 ring-blue-100"
                    >
                      {user.first_name[0]}{user.last_name[0]}
                    </Avatar>
                  )}
                </Tooltip>
              ))}
              
              {assignMembers.length > 2 && (
                <Tooltip
                  label={`+${assignMembers.length - 2} more assigned`}
                  withArrow
                  color="gray"
                  position="top"
                >
                  <Avatar radius="xl" size={28} color="gray" className="ring-2 ring-gray-100">
                    +{assignMembers.length - 2}
                  </Avatar>
                </Tooltip>
              )}
            </Avatar.Group>

            {canAssign && (
              <Tooltip
                color="blue"
                label="Manage assignments"
                withArrow
                position="top"
              >
                <Button
                  size="xs"
                  variant="light"
                  onClick={open}
                  color="blue"
                  className="hover:bg-blue-50 ml-1 h-7 w-7 p-0 rounded-full"
                >
                  <IconPlus size={14} />
                </Button>
              </Tooltip>
            )}
          </div>
        </Tooltip.Group>
      </div>
    </>
  );
};

const Guide = ({ tab }) => {
  const [showTools, setShowTools] = useState(false);
  const [guide, setGuide] = useState(tab.guide);

  const handleUpdate = async () => {
    try {
      const response = await fetchApi(
        `/sub_categories/${tab.id}/update_guide`,
        "PATCH",
        {
          sub_category: { guide },
        }
      );

      if (response.ok) {
        const res = await response.json();
        setShowTools(false);
        console.log(res);
      } else {
        const msg = (await response.json()).error;
        // setNotification({ type: "failure", content: msg });
        console.error(msg);
      }
    } catch (error) {
      console.error("Error during updating guide:", error);
    }
  };

  return (
    <Card radius="md" p={0} withBorder className="px-4 mt-3 h-fit">
      <Group className="pt-4 pl-4">
        <Title order={4} size="h4" fw={700}>
          Guide
        </Title>
        {tab.editable && (
          <ActionIcon
            component="a"
            href={`#`}
            size={28}
            variant="default"
            aria-label="Edit guide"
            onClick={() => setShowTools(!showTools)}
          >
            {showTools ? (
              <IconX style={{ width: rem(18), height: rem(18) }} stroke={2.5} />
            ) : (
              <IconPencil
                style={{ width: rem(18), height: rem(18) }}
                stroke={2.5}
              />
            )}
          </ActionIcon>
        )}
        {showTools && (
          <ActionIcon
            component="a"
            href={`#`}
            size={28}
            variant="default"
            aria-label="Edit guide"
            onClick={handleUpdate}
          >
            <IconCheck
              style={{ width: rem(18), height: rem(18) }}
              stroke={2.5}
            />
          </ActionIcon>
        )}
      </Group>
      <Markdown
        value={guide || ""}
        visibleDragbar={false}
        preview={"preview"}
        hideToolbar={true}
        height={300}
        setValue={setGuide}
      />
    </Card>
  );
};
